import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../services/api";
import { setRepeatTimeOut } from "./authSlice";

export const fetchUserData = createAsyncThunk(
  //   "candidates/login",
  "user/",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/user");
      return { ...response.data };
    } catch (e) {
      return rejectWithValue("");
    }
  }
);


export const login = createAsyncThunk(
  "candidates/login",
  async (candidate, { rejectWithValue, dispatch, getState }) => {
    dispatch(setRepeatTimeOut(null));
    try {
      const controller = new AbortController();
      const signal = controller.signal;

      const response = await api.post(
        "/candidates/login",
        { candidate },
        { signal }
      );
      // Example: You can cancel the request if needed
      // controller.abort();
      if (!response.data?.token) {
        const timeoutId = window.setTimeout(() => {
          const {
            auth: { userData },
            examDetail: { details },
          } = getState();
          if (!userData?.email) return;
          dispatch(
            login({
              email: userData?.email,
              exam: details?._id,
            })
          );
        }, 2000);

        const {
          auth: { userData, loginCount },
          examDetail: { details },
        } = getState();
        console.log("this is it", { userData, loginCount, details });
        if (!userData?.email && !details?._id && loginCount) {
          console.log("Setting timeout for login retry");
          return { message: null, token: null, data: null };
        }
        dispatch(setRepeatTimeOut(timeoutId));
      }
      return response.data;
    } catch (err) {
      if (err.response) {
        if (err.name === "CanceledError" || err.name === "AbortError") {
          return rejectWithValue("");
        }
        return rejectWithValue(err.response.data.message);
      } else {
        return rejectWithValue("Network Error.");
      }
    }
  }
);
